import Footer from '../../components/footer/footer2nd'
import Nav from '../../components/nav/nav2nd'
import React from 'react'
import { Row,Col, Input, Button} from 'antd'


const StoreLocator2nd = () => {
  return (
    <>
        <Nav/>
        <main>
            <div className='light-blue'>
                <header className='body-h'>
                  Store locator
                 </header>
                <Row className='white-back' gutter={[32,0]}>
                  <Col md={{span: 12}} sm={{span: 24}} className='left-col'>
                  <div className='r-div'>
                    <div className='locators'>
                      <img src="https://res.cloudinary.com/dzvhmiutm/image/upload/v1679915441/birdies/pinBlue_nh2wuo.png" alt="" className='pin-pic'/>
                    </div>
                    <h2 className='enter-h'>
                    Enter your address
                    </h2>
                    <p className='search-p'>
                    Search for stores closer to your location
                    </p>
                    <Input placeholder='Enter your address'/>
                  </div>
                  <Button className='search-but'>
                      Search
                  </Button>
                  </Col>
                  <Col md={{span: 12}} sm={{span: 24}} className='right-col'>
                  <div className='l-div'>
                    <img src="https://res.cloudinary.com/dzvhmiutm/image/upload/v1679915216/birdies/locator_map_w39len.png" alt="picture_of_map" className='geo-map' />

                  </div>
                  </Col>
                </Row>
            </div>
        </main>
        <Footer/>
    </>
  )
}

export default StoreLocator2nd